import { Injectable, EventEmitter } from '@angular/core';
import { UIRadioComponent } from './radio.component';

@Injectable({ providedIn: 'root' })
export class UIRadioButtonService {
    select: EventEmitter<UIRadioComponent> = new EventEmitter();

    constructor() {}
}
